import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiChibiMakerConfig } from '@/data/landingConfig/landingAiChibiMakerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiChibiMaker } from './schemaObject';

interface Props {}
const AiChibiMaker: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiChibiMaker} />
			<LandingTemplate
				data={landingAiChibiMakerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAnimeGenerator()}
			/>
		</>
	);
};

export default AiChibiMaker;
